import { http } from '@pendo/http';

export async function getAutoFeatureConfig (appId) {
    try {
        const autoFeatureConfig = await http.get(`/api/s/_SID_/application/${appId}/autoFeatureConfig`);

        return autoFeatureConfig.data;
    } catch {
        const newAutoFeatureConfig = await createAutoFeatureConfig(appId);

        return newAutoFeatureConfig;
    }
}

export async function createAutoFeatureConfig (appId) {
    const newAutoFeatureConfig = {
        enabled: false,
        maxFeatures: 10,
        availableTaggingAttributes: [],
        selectedTaggingAttributes: [],
    };

    try {
        const response = await http.post(`/api/s/_SID_/application/${appId}/autoFeatureConfig`, newAutoFeatureConfig);

        return response.data;
    } catch (error) {
        throw new Error(error);
    }
}

export async function updateAutoFeatureConfigProperty (appId, property, oldValue, newValue) {
    const payload = {
        patch: [
            {
                op: 'test',
                path: `/${property}`,
                value: oldValue,
            },
            {
                op: 'replace',
                path: `/${property}`,
                value: newValue,
            },
        ],
    };

    try {
        const response = await http.patch(`/api/s/_SID_/application/${appId}/autoFeatureConfig`, payload);

        return response.data;
    } catch (error) {
        throw new Error(error);
    }
}
